<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <!-- Header Block -->
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png" /> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin: 10px; border-radius: 10px">
      <div class="">
        <div class="row">
          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px">
            <p class="my-auto ml-3" style="font-size: 20px; font-weight: 600">
              Enter The Molecule
            </p>
          </div>

          <div class="col-5 col-md-5 col-sm-12" style="margin: 10px">
            <i class="fa fa-search icon" style="margin-right: 10px"></i>
            <input class="w-75" placeholder="Enter the Molecule" [(ngModel)]="brandname"
              (keydown.enter)="searchMolecule1()" autofocus />
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px">
            <button type="button" class="btn btn-light" (click)="searchMolecule1()">
              Submit
            </button>
          </div>
          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px">
            <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
              [style]="{ width: '90%', 'font-size': '12px' }" optionLabel="name" placeholder="Select NDA"
              (click)="searchMolecule()" *ngIf="subMolecule">
            </p-dropdown>
          </div>
          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px">
            <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
          </div>
        </div>
      </div>
    </div>
    <div style="float: left">
      <p-tabView>
        <p-tabPanel header="Upload Files">
          <div class="card cost-api-card" style="padding: 2rem; margin-left: 1rem">
            <p style="font-weight: bold">Sales and Volume:</p>
            <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">
              <div class="row">
                <div class="text-center col-sm-6 col-md-6 col-lg-4">
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" id="customFile" name="myfile"
                      (change)="onFileSelect($event)" #UploadFileInput />
                    <label class="custom-file-label" for="customFile">{{
                      fileInputLabel || "Choose File"
                      }}</label>
                  </div>
                </div>
                <div class="text-center">
                  <button class="btn btn-primary" type="submit">
                    <i class="fa fa-upload mr-2"></i>Upload
                  </button>
                  <button class="btn btn-primary" style="float: right;margin-bottom: 1rem;margin-left: 1rem;"
                    (click)="downloadSalesReports()"><i class="fa fa-download icons mr-2"></i>Download Sales-Volume
                    Report</button>
                </div>
              </div>
            </form>

            <div class="row table-responsive" style="margin-top: 20px; width: 85rem !important"></div>
          </div>
        </p-tabPanel>
      </p-tabView>

      <div class="container-fluid">
        <div class="tab-execsum">
          <div>
            <p-accordion expandIcon="pi pi-chevron-circle-down" [multiple]="true"
              collapseIcon="pi pi-chevron-circle-up">
              <p-accordionTab header="PRODUCT DETAILS" [selected]="true">
                <table class="table table-bordered" id="excel-table">
                  <div class="table-responsive">
                    <tbody>
                      <tr>
                        <ng-container *ngFor="let headers of ProductData | keyvalue" id="Tableproduct">
                      <tr>
                        <td>
                          <p>{{ headers.key }}</p>
                        </td>
                        <td>
                          <p>{{ headers.value }}</p>
                        </td>
                      </tr>
                      </ng-container>
                      </tr>
                    </tbody>
                  </div>
                </table>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>
      </div>
      <div class="nodata" *ngIf="noData">
        <p>No Data Found</p>
      </div>

      <div>
        <div style="display: flex; justify-content: flex-end; margin: 20px; margin-bottom: 10px;">
          <button (click)="toggleEditSave()" class="btn btn-success">
            {{ showedit ? 'Save All' : 'Edit' }}
          </button>
        </div>

        <h3 style="margin-left: 20px">5 year Sales</h3>
        <div class="table-responsive" style="margin-left: 20px">
          <table class="table table-bordered" id="sales-table">
            <thead>
              <tr>
                <th *ngFor="let header of salesheader">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of Stregnth; let i = index">
                <td *ngFor="let key of salesheader; let j = index">
                  <p *ngIf="showedit && key !== 'Fill Volume/Weight (ml or gm)' && key !== 'Strengths (mg)'">
                    <input type="text" [id]="'sales' + i + 'row' + j" [value]="row[key]" />
                  </p>
                  <p *ngIf="!showedit || key === 'Fill Volume/Weight (ml or gm)' || key === 'Strengths (mg)'">
                    {{ row[key] }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 style="margin-left: 20px">5 year Volume</h3>
        <div class="table-responsive" style="margin-left: 20px">
          <table class="table table-bordered" id="volume-table">
            <thead>
              <tr>
                <th *ngFor="let header of volumeheader">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of VolumeStregnth; let i = index">
                <td *ngFor="let key of volumeheader; let j = index">
                  <p *ngIf="showedit && key !== 'Fill Volume/Weight (ml or gm)' && key !== 'Strengths (mg)'">
                    <input type="text" [id]="'volume' + i + 'row' + j" [value]="row[key]" />
                  </p>
                  <p *ngIf="!showedit || key === 'Fill Volume/Weight (ml or gm)' || key === 'Strengths (mg)'">
                    {{ row[key] }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>